import React from "react"
import { connect } from "react-redux"
import logo from "../../assets/images/brand.png"
import CircularProgress from "@material-ui/core/CircularProgress"
import { logout, magicLink } from "../../actions/authentication"
import { setVisibility } from "../../actions/message-drawer"
import styles from "./styles"
import { compose } from "recompose"
import { withStyles } from "@material-ui/core/styles"
import { toggleProfileDialog } from "../../actions/users"
import { toggleReferCrewDialog } from "../../actions/crew"
import { switchActiveCompany } from "../../actions/companies"

class MagicLink extends React.Component {
  componentDidMount() {
    this.props.dispatch(logout())
    this.props.dispatch(switchActiveCompany(null, ""))
    this.props.dispatch(setVisibility(false))
    this.props
      .dispatch(magicLink(this.props.match.params.short_code))
      .then(response => {
        if (this.props.location.search === "?=ref") {
          this.props.history.push(`/`)
          this.props.dispatch(toggleReferCrewDialog(true))
          return
        }
        if (this.props.match.params["0"]) {
          this.props.history.push(`/${this.props.match.params["0"]}`)
        } else {
          this.props.history.push("/")
          this.props.dispatch(toggleProfileDialog(true, response))
          return
        }
        if (response.roles.length === 0) {
          this.props.dispatch(toggleProfileDialog(true, response))
        }
      })
  }
  componentWillUnmount() {
    this.props.dispatch(setVisibility(true))
  }

  render() {
    return (
      <div className={this.props.classes.wrapper}>
        <div>
          <img
            src={logo}
            alt="adesk logo"
            className={this.props.classes.logoImage}
          />
        </div>{" "}
        <div className={this.props.classes.loader}>
          <CircularProgress size={50} />{" "}
        </div>{" "}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  authentication: state.authentication
})

export default compose(
  connect(mapStateToProps),
  withStyles(styles, {
    withTheme: true
  })
)(MagicLink)
